<template>
    <div>
        <p>For every participant that signs up using this link, {{ referrerText }} will earn {{
            referralScheme.credit_amount_per_signup | money(referralScheme.currency)
        }}</p>
        <span v-if="referralScheme.side_of_benefit === sideOfBenefitBoth">
            <hr>
            <h5>Give Your Friends
                <referral-amount :referral-scheme=referralScheme></referral-amount> Off
            </h5>
                <p>Give a discount to your friends - Share your unique discount code for use at checkout</p>
            <div class="text-center">
                <span class="box-outline">{{ userReferrerCode }}</span>
            </div>
        </span>
    </div>
</template>

<script>
import {money} from '../Utility/filters/money';
import SidesOfBenefit from "./consts/sides_of_benefit";
import ReferralAmount from "./ReferralAmount";

export default {
    name: 'DisplayReferralBenefits',

    components: {
        ReferralAmount
    },

    filters: {
        money,
    },

    props: {
        referralScheme: {
            required: true,
            type: Object,
        },
        referralText: {
            default: 'the referral',
            required: false,
            type: String,
        },
        referrerText: {
            default: 'the referrer',
            required: false,
            type: String,
        },
        userReferrerCode: {
            required: true,
            type: String,
        },
    },

    data() {
        return {
            sideOfBenefitBoth: SidesOfBenefit.SIDE_OF_BENEFIT_BOTH,
        }
    },
}
</script>
<style lang="scss" scoped>
.box-outline {
    border: 3px solid #28a745;
    padding: 10px 20px;
    border-radius: 10px;
    font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/Assets/components/ReferralSchemes/DisplayBenefits.vue